<div class="tracks-list">
  @if(isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div>
    <table mat-table #table
           [dataSource]="dataSource()" matSort matSortDisableClear style="background: none" (matSortChange)="sortChange($event)">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let index = index">
          <mat-icon class="track-icon mt-8"
                    (click)="play(index, row)"
                    [class.track-icon__current]="playerSource.currentTrack() && playerSource.currentTrack()?.id === row.id">play_circle</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TITLE </th>
        <td mat-cell *matCellDef="let row; let index = index">
          <span>{{row.title}}</span>



        </td>
      </ng-container>

      <ng-container matColumnDef="artists">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ARTIST </th>
        <td mat-cell *matCellDef="let row">
          {{row.artists}}
        </td>
      </ng-container>

      <ng-container matColumnDef="genre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> GENRE </th>
        <td mat-cell *matCellDef="let row"> {{ row.genre }} </td>
      </ng-container>
      <ng-container matColumnDef="bpm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> BPM </th>
        <td mat-cell *matCellDef="let row"> {{row.bpm }}</td>
      </ng-container>

      <ng-container matColumnDef="releaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> DATE </th>
        <td mat-cell *matCellDef="let row"> {{row.releaseDate | date:'MM/dd/yyyy' }} </td>
      </ng-container>

      <ng-container matColumnDef="downloads" >
        <th mat-header-cell *matHeaderCellDef>DOWNLOADS</th>
        <td mat-cell *matCellDef="let row">
          <div class="d-flex align-center gap-5" style="width: 60px">
            <div class="circle" [ngClass]="row.downloadsCount > 0 ? 'circle__on' : 'circle__off'"></div>
            <div class="circle" [ngClass]="row.downloadsCount > 1 ? 'circle__on' : 'circle__off'"></div>
            <div class="circle" [ngClass]="row.downloadsCount > 2 ? 'circle__on' : 'circle__off'"></div>

<!--            @if(row.downloadsCount > 0) {-->
<!--              @for(item of [].constructor(row.downloadsCount); track item) {-->
<!--                <div class="circle circle__on"></div>-->
<!--              }-->
<!--            }-->

<!--            @if(row.downloadsCount < 3) {-->
<!--              @for(item of [].constructor(3 - row.downloadsCount); track item) {-->
<!--                <div class="circle circle__off"></div>-->
<!--              }-->
<!--            }-->

          </div>

        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="d-flex justify-between align-center gap-10">
            <span class="material-symbols-outlined pointer download-icon" [class.disabled]="row.downloadsCount > 2 || tracksStore.downloadsLeft() < 1" (click)="download(row)">download</span>
          </div>

        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="track-row"
          [ngClass]="{'row-current': playerSource.currentTrack() && playerSource.currentTrack()?.id === row.id,
           'previewed': row.previewed?.length > 0,
           'available': row.downloadsCount > 0 &&  row.downloadsCount < 3, 'fully-downloaded': row.downloadsCount > 2}"

      ></tr>

    </table>

    @if(showPaginator()) {
      <app-custom-paginator [total]="tracksTotal()" [index]="pageIndex()" (pageChanged)="changePage($event)"></app-custom-paginator>

    }

  </div>

</div>
